<template>
  <v-container>
    <div class="d-flex align-center justify-space-between">
      <div class="d-flex align-center" style="flex: 1">
        <img style="height: 65px" src="@assets/images/logo.svg" />
        <div class="ml-6">
          <div style="font-size: 22px; font-weight: 600; color: #2b713a"
            >TỔNG CỤC MÔI TRƯỜNG</div
          >
          <div style="font-size: 13px; font-weight: 400; color: #2b713a"
            >VIETNAM ENVIROMENT ADMINISTRATION</div
          >
        </div>
      </div>
      <div class="d-flex desktop-menu">
        <!-- <div class="button-header">Tài liệu</div>
        <div class="button-header">Tính năng</div>
        <div class="button-header">Liên hệ</div> -->
        <div
          class="button-header button-panel-header"
          @click="goDashboard"
          v-if="currentId"
          >Bảng điều khiển</div
        >
        <div class="button-header button-panel-header" @click="gotoLogin" v-else
          >Đăng nhập</div
        >
      </div>
      <div class="mobile-menu">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon>
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </template>
          <v-list>
            <!-- <v-list-item>
              <v-list-item-title>Tài liệu</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Tính năng</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Liên hệ</v-list-item-title>
            </v-list-item> -->
            <v-list-item @click="goDashboard" v-if="currentId">
              <v-list-item-title>Bảng điều khiển</v-list-item-title>
            </v-list-item>
            <v-list-item @click="gotoLogin" v-else>
              <v-list-item-title>Đăng nhập</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({}),
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
  },
  methods: {
    goDashboard() {
      this.$router.push({
        name: 'home',
      })
    },
    gotoLogin() {
      this.$router.push({
        name: 'login',
      })
    },
  },
}
</script>

<style scoped>
.button-header {
  color: #263238;
  font-weight: 600;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 10px;
  height: 36px;
}
.button-panel-header {
  border-radius: 3px;
  background: #f2e205;
}
.button-header:hover {
  color: #2b713a;
}
.button-panel-header:hover {
  background: #c2d200;
  color: black;
}
.mobile-menu {
  display: none;
}

@media only screen and (max-width: 850px) {
  .desktop-menu {
    display: none !important;
  }
  .mobile-menu {
    display: block;
  }
}
</style>